import React from 'react';
import { styles } from '../styles/styles';
import phoneIcon from '../assets/contact-icons/phone.svg';

const Header = () => {
  return (
    <header style={styles.header}>
      <div style={styles.headerContainer}>
        <div style={styles.headerLogo}>
            <img 
            src="/images/metro-logo.png" 
            alt="Metro Mowing Logo" 
            style={{ 
              height: '2rem', 
              width: 'auto', 
              marginRight: '0.5rem' 
            }}
          />
          <h1 style={styles.headerTitle}>Metro Mowing</h1>
        </div>
        <div style={styles.headerNav} className="mobile-hide">
          <a href="tel:6513137009" style={styles.headerPhone}>
            <img
              src={phoneIcon}
              alt=""
              style={{ width: '20px', height: '20px', marginRight: '0.4rem', filter: 'invert(1)' }}
            />
            (651) 313-7009
          </a>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            style={styles.headerButton}
          >
            Get Quote
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;